<template>
  <div>
    <DxPopup
      :visible="isVisible"
      :close-on-outside-click="true"
      :show-close-button="false"
      :drag-enabled="false"
      :show-title="false"
      class="custom-tutorial-popup"
      width="auto"
      height="auto"
      container=".dx-viewport"
      @hiding="hide"
    >
      <div class="popup-content">
        <button
          type="button"
          class="popup-close"
          aria-label="Cerrar"
          @click="hide"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <iframe
          v-if="isVisible"
          width="1000"
          height="562"
          :src="safeEmbedSrc"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { mapState, mapActions } from 'vuex';
import EventBus from '@/services/event-bus';

export default {
  components: { DxPopup },
  data() {
    return { isVisible: false };
  },
  computed: {
    ...mapState('videoPeriodModule', ['currentVideo']),
    safeEmbedSrc() {
      const u = this.currentVideo?.url || '';
      try {
        const url = new URL(u);
        const id = url.pathname.split('/').pop();
        const origin = encodeURIComponent(window.location.origin);
        return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&rel=0&modestbranding=1&playsinline=1&origin=${origin}`;
      } catch {
        return '';
      }
    },
  },
  created() {
    EventBus.$on('show-video-popup', this.show);
  },
  beforeDestroy() {
    EventBus.$off('show-video-popup', this.show);
  },
  methods: {
    hide() {
      this.isVisible = false;
      this.setMaxShowCount(); // persiste por email + vídeo
    },
    show() {
      this.isVisible = true;
    },
    ...mapActions('videoPeriodModule', ['setMaxShowCount']),
  },
};
</script>

<style lang="scss">
@import './tutorialPopUp.styless.scss';
</style>
